import React from 'react';
export function SellosBar() {
  return <div className="bg-[#0a0a0a] border-t border-brand-border py-6 px-6" data-id="element-256">
      <div className="max-w-[700px] mx-auto flex flex-wrap justify-center gap-6" data-id="element-257">
        <div className="flex items-center gap-2 text-[13px] text-brand-muted" data-id="element-258">
          <span data-id="element-259">🔒</span>Pago 100% seguro
        </div>
        <div className="flex items-center gap-2 text-[13px] text-brand-muted" data-id="element-260">
          <span data-id="element-261">⚡</span>Acceso en 5 minutos
        </div>
        <div className="flex items-center gap-2 text-[13px] text-brand-muted" data-id="element-262">
          <span data-id="element-263">✅</span>Garantía 7 días
        </div>
        <div className="flex items-center gap-2 text-[13px] text-brand-muted" data-id="element-264">
          <span data-id="element-265">💳</span>MercadoPago
        </div>
        <div className="flex items-center gap-2 text-[13px] text-brand-muted" data-id="element-266">
          <span data-id="element-267">💳</span>Tarjeta de crédito
        </div>
        <div className="flex items-center gap-2 text-[13px] text-brand-muted" data-id="element-268">
          <span data-id="element-269">🏦</span>Transferencia bancaria
        </div>
      </div>
    </div>;
}